import { IS_PROD } from '../constants/env';
import { defaultFeatureConfig } from './defaultFeatureConfig';
import { getFeatureConfigFromSessionStorage } from './utils';

/**
 * Provides the application's feature configuration based on the environment.
 *
 * - In production (`IS_PROD` is `true`), returns the `defaultFeatureConfig`.
 * - In non-production environments, retrieves the feature configuration from session storage using `getFeatureConfigFromSessionStorage()`.
 *
 * @remarks
 * This constant allows dynamic feature toggling during development while ensuring a stable configuration in production.
 */
export const featureConfig = IS_PROD
  ? defaultFeatureConfig
  : getFeatureConfigFromSessionStorage();
